export default "__VITE_ASSET__Dk_H5rpU__"